import classNames from 'classnames';
import { Button, Heading } from 'yoso';
import { useAdventure } from '~/components/Adventure/Adventure.hooks';
import { BaseCard } from '~/components/Card';
import heroStyles from '~/components/Hero/Hero.module.scss';
import { T } from '~/components/I18n';
import { DescriptionList } from '~/components/List/Description/DescriptionList';
import { Link, LinkProps } from '~/components/Route/Link';
import { regularFormat } from '~/components/Util';
import type { AdventureHeroProps } from '../AdventureHero';
import styles from '../AdventureHero.module.scss';

export const UpcomingAdventureHero = ({ id, className }: AdventureHeroProps) => {
  const { data: { startAt } = {} } = useAdventure(id);

  return (
    <BaseCard className={classNames(styles.root, heroStyles.root, className)} size="large">
      <Heading level={3} className={heroStyles.heading}>
        Adventure Week {id}
        <br />
        11.27 Tuesday 09:00 Open
        <br />
        Look forward to various NFTs!
      </Heading>
      <DescriptionList layout="responsive" className={heroStyles.sublist}>
        <dt>Open</dt>
        <dd>{regularFormat(startAt, 'PPPP p')}</dd>
      </DescriptionList>
      <Button<LinkProps>
        className={classNames(heroStyles.button, heroStyles.fixedButton)}
        as={Link}
        to="/support/notice?category=winners"
        size="large">
        <T name="citizen_button_title_go_winners" />
      </Button>
    </BaseCard>
  );
};
